<div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeModal()">&times;</button>
    <h4 class="modal-title wrap-text-in">{{modalData.requisitionSPOC.titleName}}</h4>
</div>
<form role="form" #backwardactionform="ngForm" id="backwardactionform"
    (ngSubmit)="backwardactionform.valid && onModifyRequisitionStates()" novalidate>
    <div class="modal-body">

        <div class="form-group wrap-text-in">
            <label class="modal-body-font-size"
                *ngIf="modalData.requisitionSPOC.titleName !== MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_FILLED_CANDIDATE && modalData.requisitionSPOC.titleName !== MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_JOINED_CANDIDATE">
                <span class="updateReqtextcolor">'{{modalData.requisitionSPOC.currentStateName}}' </span>the
                Requisition
                <span class="updateReqtextcolor"> '{{modalData.requisitionSPOC.Role}}' </span>for
                <span class="updateReqtextcolor"> '{{modalData.requisitionSPOC.Company}}'</span>
            </label>
            <label class="modal-body-font-size">
                <br> Are you sure you want to continue?
            </label>
        </div>

        <div class="form-group">
            <div class="row">
                <div class="col-xs-6" [ngClass]="{'has-error':(backwardactionform.submitted && fromDate.invalid)}">
                    <label for="fromDate">Date <em> * </em></label>
                    <div class="input-group">
                        <span class="input-group-addon"> <i class="fa fa-calendar"></i></span>
                        <input type="text" class="form-control" placeholder="mm-dd-yyyy" id="fromDate" name="fromDate"
                            [(ngModel)]="modalData.requisitionSPOC.date" #fromDate="ngModel" required>
                    </div>
                    <div class="error error-gap" *ngIf="backwardactionform.submitted">
                        <small *ngIf="fromDate.errors?.required"><em>*</em> Date is required</small>
                    </div>
                </div>

                <div class="col-xs-6" [ngClass]="{'has-error':(backwardactionform.submitted && time.invalid)}">
                    <label for="time-pooja">Time <em> * </em></label>
                    <div class="input-group">
                        <span class="input-group-addon"><i class="far fa-clock"></i></span>
                        <input type="text" class="form-control" placeholder="hh:mm:ss" [(ngModel)]="modalData.requisitionSPOC.time"
                            id="time-pooja" name="time" #time="ngModel" required>
                    </div>
                    <div class="error error-gap" *ngIf="backwardactionform.submitted">
                        <small *ngIf="time.errors?.required"><em>*</em> Time is required </small>
                    </div>
                </div>

            </div>
        </div>

        <div class="form-group"
            [ngClass]="{'has-error':(backwardactionform.submitted && modalData.requisitionSPOC.candidate === undefined)}"
            *ngIf="modalData.requisitionSPOC.titleName === MESSAGECONSTANTS.VIEW_REQUISITION.FILL_STATE || modalData.requisitionSPOC.titleName === MESSAGECONSTANTS.VIEW_REQUISITION.JOIN_STATE || modalData.requisitionSPOC.titleName === MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_FILLED_CANDIDATE || modalData.requisitionSPOC.titleName === MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_JOINED_CANDIDATE">
            <label for="candidateSelected">Candidate <em> * </em></label>
            <select id="candidateSelected" name="candidateSelected" class="form-control btn btn-secondary inputBoxBorder dropdown-toggle"
                [(ngModel)]="modalData.requisitionSPOC.candidate" (ngModelChange)="onCandidateChange()">
                <option *ngFor="let t of modalData.candidates" [ngValue]="t">{{t.name}}</option>
            </select>
            <div class="error error-gap" *ngIf="backwardactionform.submitted">
                <small *ngIf="modalData.requisitionSPOC.candidate === undefined"><em>*</em>
                    Please select a candidate to remove</small>
            </div>
        </div>

        <!-- Reason -->
        <div class="form-group"
            [ngClass]="{'has-error':(backwardactionform.submitted && reason.invalid)}"
            *ngIf="modalData.requisitionSPOC.titleName === MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_FILLED_CANDIDATE || modalData.requisitionSPOC.titleName === MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_JOINED_CANDIDATE">
            <label for="reason">
                Reason<em> * </em>
            </label>
            <select class="form-control" name="reason" id="reason" #reason="ngModel"
                [(ngModel)]="modalData.requisitionSPOC.reasonCodeDTO" required>
                <option *ngFor="let r of modalData.reasonCodes" [ngValue]="r">{{r.reason}}</option>
            </select>
            <div class="error error-gap" *ngIf="backwardactionform.submitted">
                <small *ngIf="reason.errors?.required"><em>*</em>
                    Please select a reason</small>
            </div>
        </div>

        <div class="form-group" [ngClass]="{'has-error':(backwardactionform.submitted && note.invalid)}">
            <label for="note"> Internal Notes <em> * </em></label>
            <div>
                <!-- Voice Input -->
                <div class="mb-2">
                    <app-voice-input
                        (transcriptReady)="onVoiceTranscript($event)"
                        [sourceScreen]="'REQ'"
                        [candidate]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.candidate : null"
                        [company]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.company : null"
                        [requisition]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.requisition : null"
                        [jobMatch]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.jobMatch : null">
                    </app-voice-input>
                </div>
                <textarea name="note" class="form-control"
                    style="height: 100px; width: 100%; resize: none;" maxlength="503" [(ngModel)]="modalData.requisitionSPOC.note"
                    #note="ngModel" required
                    (ngModelChange)="modalData.isSharedRequisition && copyNote && onInternalNoteChanged()">
                </textarea>
            </div>

            <div class="error error-gap" *ngIf="backwardactionform.submitted">
                <small *ngIf="note.errors?.required"><em>*</em>
                    Note is required</small>
            </div>
            <!-- Formalize Text -->
            <app-formalize-comment
                [inputText]="modalData.requisitionSPOC.note"
                (outputText)="receiveFormalizedComment($event)"
                [sourceScreen]="'REQUISITION'"
                [candidate]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.candidate : null"
                [company]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.company : null"
                [requisition]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.requisition : null"
                [jobMatch]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.jobMatch : null">
            </app-formalize-comment>
        </div>
        <app-external-notes
            *ngIf="modalData.isSharedRequisition && (modalData.requisitionSPOC.titleName === MESSAGECONSTANTS.VIEW_REQUISITION.FILL_STATE || modalData.requisitionSPOC.titleName === MESSAGECONSTANTS.VIEW_REQUISITION.JOIN_STATE || modalData.requisitionSPOC.titleName === MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_FILLED_CANDIDATE || modalData.requisitionSPOC.titleName === MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_JOINED_CANDIDATE)"
            [form]="backwardactionform"
            [note]="modalData.requisitionSPOC.note"
            [copyNote]="copyNote"
            [externalNote]="modalData.requisitionSPOC.externalNote"
            (onExternalNoteChange)="onExternalNoteChange($event)"
            (onCopyNoteChange)="onCopyNoteChange($event)"
            [sourceScreen]="'REQUISITION'"
            [formalizeActivityPayload]="modalData.formalizeActivityPayload">
        </app-external-notes>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="closeModal()">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="disableSubmit">Ok</button>
    </div>
</form>
